import type {
  GeocodeParams,
  GeocodeResponse,
  LocationAutocompleteParams,
  LocationAutocompleteResponse,
} from '@/api/types/autocomplete'
import { stringifyParams } from '@/lib/helpers'

import { sliceApi } from './api'

const autocompleteSliceApi = sliceApi
  .enhanceEndpoints({ addTagTypes: ['LocationAutocomplete', 'Geocode'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getLocationAutocomplete: builder.query<
        LocationAutocompleteResponse,
        LocationAutocompleteParams
      >({
        query: (params) =>
          `/public/map/place-autocomplete${stringifyParams(params)}`,
        providesTags: (_result, _error, params) => [
          { type: 'LocationAutocomplete' as const, id: params.input },
        ],
      }),
      getGeocode: builder.query<GeocodeResponse, GeocodeParams>({
        query: (params) =>
          `/public/map/place-coordinates${stringifyParams(params)}`,
        providesTags: (_result, _error, params) => [
          { type: 'Geocode' as const, id: params.placeId },
        ],
      }),
    }),
    overrideExisting: false,
  })

export const { useLazyGetLocationAutocompleteQuery, useLazyGetGeocodeQuery } =
  autocompleteSliceApi
